import { render, staticRenderFns } from "./SchoolInfoSection.vue?vue&type=template&id=bc1944ac"
import script from "./SchoolInfoSection.vue?vue&type=script&lang=js"
export * from "./SchoolInfoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc1944ac')) {
      api.createRecord('bc1944ac', component.options)
    } else {
      api.reload('bc1944ac', component.options)
    }
    module.hot.accept("./SchoolInfoSection.vue?vue&type=template&id=bc1944ac", function () {
      api.rerender('bc1944ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/one-part-a/components/SchoolInfoSection.vue"
export default component.exports